import React from 'react';

const Allies = () => {
  // Importar todas las imágenes de la carpeta allies
  const images = require.context('../assets/images/allies', false, /\.(png|jpe?g|svg)$/);
  const imageList = images.keys().map(image => ({
    src: images(image),
    name: image.replace('./', '').split('.')[0] // Obtener el nombre del archivo sin extensión
  }));

  return (
    <section className="allies-section py-16 bg-brand-black w-full">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-brand-gold">Nuestros Aliados</h2>
        <div className="flex flex-wrap justify-center items-center gap-12">
          {imageList.map((image, index) => (
            <div 
              key={index} 
              className="flex items-center justify-center p-6 w-[250px] h-[180px] bg-brand-black/50 rounded-lg border border-brand-gold/30 hover:border-brand-gold backdrop-blur-sm transition-all duration-300"
            >
              <img
                src={image.src}
                alt={`Logo de ${image.name}`}
                className="w-auto h-auto max-w-[200px] max-h-[150px] object-contain brightness-90 hover:brightness-100 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Allies;
